
import React from "react";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { i18nManager as globalI18nManager } from "../../../../../i18n";
import { ITeamHistory, Status } from "../../../../../services";

export interface TeamCardProps {
    visible?: boolean;
    team: ITeamHistory;
}

function TeamCard({ team: t, visible = true }: TeamCardProps) {

    const labels = i18nManager.Labels.team_history;
    const apps = t.extra_data?.appearance_count ?? 0;
    const won = t.extra_data?.appearance_won ?? 0;
    const winRate = apps > 0 ? Math.min(100, Math.round((won / apps) * 100)) : 0;
    const country = t.country_code ? globalI18nManager.queryCountryCurrency(t.country_code, "country_code", "country_name") : null;
    const achievements: string[] = t.team_extra_data?.recent_achievements ?? [];

    return (<a className={styles["team-card"]} target="_blank" rel="noreferrer" href={`${window.location.origin}/te/${t.public_id}`}>
        <div className={styles["team-card-head"]}>
            {t.logo_url && (<img className={styles["team-card-logo"]} alt={t.name} src={t.logo_url} />)}
            <div>
                <div className={styles["team-card-name"]}>
                    {t.name}
                    {t.status === Status.ACTIVE && (<span className={styles["current-badge"]}>{labels.current}</span>)}
                </div>
                <div className={styles["team-card-years"]}>
                    {new Date(t.join_date).getFullYear()} – {t.exit_date ? new Date(t.exit_date).getFullYear() : labels.present}
                    {country && (<span className={styles["team-card-country"]}> · {country}</span>)}
                </div>
            </div>
        </div>
        <div className={styles["team-card-stats"]}>
            <div className={styles["team-card-stat"]}>
                <span className={styles["team-card-stat-val"]}>{apps}</span>
                <span className={styles["team-card-stat-lbl"]}>{labels.apps}</span>
            </div>
            <div className={styles["team-card-stat"]}>
                <span className={styles["team-card-stat-val"]}>{won}</span>
                <span className={styles["team-card-stat-lbl"]}>{labels.won}</span>
            </div>
        </div>
        <div className={styles["team-card-rate"]}>
            <div className={styles["team-card-rate-lbl"]}>{labels.win_rate.replace(":rate", `${winRate}`)}</div>
            <div className={styles["team-card-bar"]}>
                <div className={styles["team-card-bar-fill"]} style={{ width: visible ? `${winRate}%` : 0 }} />
            </div>
        </div>
        {achievements.length > 0 && (<div className={styles["team-achs"]}>
            {achievements.map((a) => <span key={a} className={styles["chip"]}>{a}</span>)}
        </div>)}
    </a>);
}

export default TeamCard;
